import { useState, useEffect } from "react";
import { useStyles } from "./modalContent";

const ReusableOpticalCarePlanModal = ({
  isOpen,
  onClose,
  mode,
  providerData,
  onSubmit,
  onDelete,
}) => {
  const classes = useStyles();

  // Initialize formData based on providerData
  const [formData, setFormData] = useState({
    name: providerData?.name || "",
    type: providerData?.type || "",
    price: providerData?.value?.Yes || "",
    subServices: providerData?.value?.SubService?.join(", ") || "",
  });
  const [error, setError] = useState(null);

  // Update formData when providerData changes
  useEffect(() => {
    setFormData({
      name: providerData?.name || "",
      type: providerData?.type || "",
      price: providerData?.value?.Yes || "",
      subServices: providerData?.value?.SubService?.join(", ") || "",
    });
  }, [providerData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (!formData.name || !formData.type || !formData.price) {
      setError("Name, Type, and Price are required.");
      return false;
    }
    if (Number(formData.price) <= 0) {
      setError("Price must be greater than 0.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    setError(null);
    if ((mode === "edit" || mode === "create") && !validateForm()) return;

    try {
      // Construct the value field based on formData
      const valueData = {
        No: 0,
        Yes: Number(formData.price),
      };
      if (formData.subServices) {
        valueData.SubService = formData.subServices
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s); // Split and clean sub-services
      }

      const payload = {
        name: formData.name,
        type: formData.type,
        value: valueData,
      };

      if (mode === "edit") {
        await onSubmit(providerData.id, payload);
      } else if (mode === "create") {
        await onSubmit(null, payload);
      } else if (mode === "delete") {
        await onDelete(providerData.id);
      }
      onClose();
    } catch (err) {
      setError("Operation failed. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "500px",
          boxShadow: "0 8px 10px rgba(0, 0, 0, 0.1)",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <h2>
          {mode === "edit"
            ? "Edit Optical Care Plan"
            : mode === "create"
            ? "Create Optical Care Plan"
            : "Delete Optical Care Plan"}
        </h2>
        {error && <p style={{ color: "red" }}>{error}</p>}

        {(mode === "edit" || mode === "create") && (
          <form>
            <div>
              <label className={classes.enroleeIdText}>Plan Name:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={classes.enroleeInputId}
                required
              />
            </div>
            <div>
              <label className={classes.enroleeIdText}>Type:</label>
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className={classes.enroleeInputId}
                required
              >
                <option value="">Select Type</option>
                <option value="optical">Optical</option>
                <option value="dental">Dental</option>
              </select>
            </div>
            <div>
              <label className={classes.enroleeIdText}>Price:</label>
              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleChange}
                className={classes.enroleeInputId}
                required
              />
            </div>
            <div>
              <label className={classes.enroleeIdText}>
                Sub-Services (optional, comma-separated):
              </label>
              <input
                type="text"
                name="subServices"
                value={formData.subServices}
                onChange={handleChange}
                className={classes.enroleeInputId}
                placeholder="e.g., Consultation/Examination, Scaling and Polishing"
              />
            </div>
          </form>
        )}

        {mode === "delete" && (
          <p>
            Are you sure you want to delete the {providerData?.name} optical
            care plan?
          </p>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "#ccc",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            style={{
              padding: "8px 16px",
              background: mode === "delete" ? "#d32f2f" : "#1976d2",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {mode === "edit" ? "Save" : mode === "create" ? "Create" : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReusableOpticalCarePlanModal;
